module.exports = __webpack_public_path__ + "ddfeaae68409445ad3dfc6b664176505.png";